import type React from 'react';

// components
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { AccountDropdown } from './accountDropdown';
import AppNavigation from './appNavigation';
import { dashboardTileLinks } from '@/tills/components/dashboard-tiles';
import packageJson from 'package.json';
import Image from 'next/image';

// component
export const Header = ({
  title = 'Lush Manager',
  dashboard = null
}: {
  title?: string;
  dashboard?: React.ReactNode;
}): JSX.Element => {
  const { lang } = useTranslation('tills');
  const router = useRouter();
  const routeFragment = router.pathname.split('/')[1];
  const section = dashboardTileLinks.find((tile) => tile.section === routeFragment);
  const managerVersion = packageJson.version;

  return (
    <div className="bg-black sticky top-0 left-0 w-full z-[100]">
      <div className="w-full max-w-[1080px] mx-auto px-3">
        <nav className="w-full h-20 flex items-center justify-between text-center">
          <AppNavigation items={dashboard} section={section?.route?.title || routeFragment} />
          <div className="hidden sm:flex sm:flex-col sm:gap-1">
            <Image
              src="https://res.cloudinary.com/lush/image/upload/v1608551257/fresh_and_flowers/homepage/lush-logo.svg"
              alt="LUSH"
              width="77"
              height="20"
            />
            <span className="text-white text-sm">
              {title} - v{managerVersion}
            </span>
          </div>
          <AccountDropdown />
        </nav>
      </div>
    </div>
  );
};
